import {useLocation, useNavigate, useParams} from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { TABLES } from '../../../../../Apis/Tables';
import { MODELS } from '../../../../../Apis/Models';
import {useCallback, useEffect, useMemo, useState} from 'react';
import { GetContractorEmployeeDetail } from '../../../../../reduxToolkit/Contractor/ContractorApi';
import {
    getColumnsEmployeeDetailsProvider,
    getExportPermissionByUserTypeId,
    getSectionsEmployeeDetailsProvider
} from '../../../../Dashboard/Contractors/Model/Models';
import { USER_TYPE_MODEL } from '../../../../../enums/userTypeEnum';
import { errorMsg } from '../../../../../Apis/functions';
import { GetProviderEmployeeDetail } from '../../../../../reduxToolkit/Providers/providersApi';

/**
 * @Author: Cecilia López Martínez
 * @JobTitle: Full Stack Developer - IBL
 * @Email: clopez@ibl.mx
 */
const EmployeeDetailsDocumentationApp = (
    {
        userType
    }
) => {

    const { id } = useParams();
    const dispatch = useDispatch();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const {state} = location;
    const tableId = `tbl_edd_employee_documentation`;
    const option = `${TABLES.USER_ACCESS_LOG_BY_USER}`;
    const moduleId = `${MODELS.UserAccessLog}`;
    const [expandedRowId, setExpandedRowId] = useState(null);
    const [elementDetails, setElementDetails] = useState(null);
    const DEV = useSelector((state) => state?.CommonsSlice?.development);
    const { permission } = useSelector((state) => state.authenticatioauthennSlice);
    const contractorId = sessionStorage.getItem('contractorId');
    const supplierId = sessionStorage.getItem('providerId');
    // Contractors and suppliers export their own employees, employees need the export
    // permission of the module the details were opened from
    const canExport = contractorId || supplierId || DEV ||
        permission?.includes(getExportPermissionByUserTypeId(userType));

    useEffect(() => {
        getDetails();
    }, [id]);

    const getDetails = () => {
        if (!id) return;

        const actionByType = {
            [USER_TYPE_MODEL.CONTRACTOR_IN_CHARGE]: GetContractorEmployeeDetail,
            [USER_TYPE_MODEL.SUPPLIER_IN_CHARGE]: GetProviderEmployeeDetail,
        };

        const action = actionByType[userType];
        if (!action) return;

        dispatch(action(id)).then(({ payload: { data: { data, success, code } } }) => {
            if (success === true) setElementDetails(data);
            else errorMsg(code);
        });
    }

    const handleRowExpand = (row) => {
        if (row?.id !== expandedRowId) {
            setExpandedRowId(row?.id);
        }
    };

    const columns = useMemo(() =>
            getColumnsEmployeeDetailsProvider(t, moduleId, option, id, canExport),
        [t, moduleId, option, id, canExport]
    );

    const sections = useMemo(() =>
            getSectionsEmployeeDetailsProvider({
                userTypeId: userType,
                userId: elementDetails?.user?.id,
                option
            }),
        [userType, elementDetails?.user?.id, option]
    );

    const renderExpandedRow = useCallback(({ row }) => row.content(), []);

    const goBack = () => {
        if(state?.backUrl){
            navigate(state.backUrl?.pathname || state.backUrl, { state: { currentSubView: state?.currentSubView || undefined}});
        }
    };

    return {
        id,
        t,
        tableId,
        option,
        moduleId,
        expandedRowId, setExpandedRowId,
        handleRowExpand,
        columns,
        sections,
        renderExpandedRow,
        goBack,
        elementDetails,
        setElementDetails
    }

}

export default EmployeeDetailsDocumentationApp
